import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import './EtchVisualNavigationStory.scss';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/overlay')
  .then((module) => ({ default: module.Overlay })));
const VideoPlayer = React.lazy(() => import(/* webpackChunkName: "video-player" */ '@thd-olt-component-react/video-player')
  .then((module) => ({ default: module.VideoPlayer })));

const EtchVisualNavigationStory = (props) => {

  const opts = props?.opts;
  const {
    ctaLink,
    type,
    image = {},
    heading,
    subHeading,
    linkList,
    id
  } = opts;
  const [videoId, setVideoId] = useState(null);
  const [overlay, setOverlay] = useState(false);
  let callToActionLink = ctaLink;
  const { src, alt, height, width } = image;
  const imgClass = classNames({
    'img--block':height && width
  });

  if (callToActionLink && callToActionLink.indexOf('playVideo') > -1) {
    callToActionLink = '#';
  }

  const onButtonClick = (event) => {
    if (ctaLink && ctaLink.indexOf('playVideo') > -1) {
      event.preventDefault();
      setVideoId(ctaLink?.match(/(\d+)/gm)?.[0])
      setOverlay(true);
    }
  }

  return (
    <>
      <div className="etchVisualNavigationStory etch-analytics" data-module-id={id} data-module-type={type}>
        <div className="etchVisualNavigationStory__container">
          <div className="etchVisualNavigationStory__card" data-module-content-id={id}>
            {callToActionLink
              && (
                <>
                  <a href={callToActionLink} onClick={onButtonClick}>
                    <Image
                      className={`etchVisualNavigationStory__card__img ${imgClass}`}
                      lazy
                      src={src}
                      alt={alt}
                      height={height}
                      width={width}
                    />
                  </a>
                  <a href={callToActionLink} className="etchVisualNavigationStory__card__title" onClick={onButtonClick}>
                    {heading}
                  </a>
                  <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                </>
              )}
            {!callToActionLink
              && (
                <>
                  <Image
                    className={`etchVisualNavigationStory__card__img ${imgClass}`}
                    lazy
                    src={src}
                    alt={alt}
                    height={height}
                    width={width}
                  />
                  <p className="etchVisualNavigationStory__card__title">{heading}</p>
                  <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                </>
              )}
            {linkList?.length > 0
              && (
                <ul className="etchVisualNavigationStory__link list list--type-plain" data-module-content-id={id}>
                  {linkList.map((link, index) => {
                    return (
                      <React.Fragment key={`${index}-${link.linkText}`}>
                        {
                          link.link
                        && (
                          <li className="list__item">
                            <a className="list__link" href={link.link}>{link.linkText}</a>
                          </li>
                        )
                        }
                        {
                          !link.link
                      && (
                        <li className="list__item">
                          {link.linkText}
                        </li>
                      )
                        }
                      </React.Fragment>
                    );
                  })}
                </ul>
              )}
          </div>
        </div>
      </div>
      {overlay && (
        <Suspense fallback={<div />}>
          <Overlay onClose={() => setOverlay(false)} open fit closeButton modalClass="etch-widgets__video-overlay__modal">
            <div className="etch-widgets__video-overlay" data-testid="visualNavStory-video-overlay">
              <VideoPlayer videoId={videoId} borderColor="black" autoPlay className="etch-widgets__video-overlay__player"/>
            </div>
          </Overlay>
        </Suspense>
      )}
    </>
  );
};

EtchVisualNavigationStory.displayName = 'EtchVisualNavigationStory';

EtchVisualNavigationStory.propTypes = {
  opts: PropTypes.shape({
    ctaLink: PropTypes.string,
    type: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    linkList: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string
    })),
    id: PropTypes.string
  })
};

EtchVisualNavigationStory.defaultProps = {
  opts: {}
};

export default EtchVisualNavigationStory;
